/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgImportFromDev = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-import-from-dev_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-import-from-dev_svg__st0"
      d="M11 5.4V12h2V5.4l1.3 1.3 1.4-1.4L12 1.6 8.3 5.3l1.4 1.4z"
    />
    <path
      className="ico-import-from-dev_svg__st0"
      d="M19 8h-4v2h1v10H8V10h1V8H5c-1.7 0-3 1.3-3 3v8c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-8c0-1.7-1.3-3-3-3zM6 20H5c-.6 0-1-.5-1-1v-8c0-.6.4-1 1-1h1v10zm14-1c0 .6-.4 1-1 1h-1V10h1c.6 0 1 .4 1 1v8z"
    />
  </Icon>
);
export { SvgImportFromDev as ImportFromDev };
